import { Environment } from './environment.model';

export const environment: Environment = {
  version: '1.3.0',
  envName: 'STAGE',
  enableSSO: true,
  prod: false,
  hash: `${new Date().toISOString().replace(/\.|:/g, '')}`,
  interval: 15000,
  jwtToken: '',
  jwtTokenExpiration: 3600,
  apiBaseUrls: {
    apiBase: 'https://pawxrb9uqz.us-west-2.awsapprunner.com',
    gatewayBaseUrl: 'https://uztpzayizd.us-west-2.awsapprunner.com',
  },
  apiEndpoints: {
    batchList: '/batch/',
    batchDelta: '/batch/:batchId/delta',
    partnerLogs: '/partner-logs'
  },
  batchExport: {
    localUserEmail: 'studio-ema-engineering-support@nbcuni.com'
  },
  sso: {
    clientId: 'f5701555-2722-4d32-8239-b66ce76f9701',
    redirectWebUri: 'https://stage.studiopulse.nbcuni.com',
    redirectLocalUri: 'http://localhost:4200',
    authUrl: 'https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/v2.0/authorize',
    tokenUrl: 'https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/token',
    scope: 'openid profile email',
    grantType: 'code',
    logoutUrl: 'https://login.microsoftonline.com/4f3526f9-97d6-412d-933a-4e30a73110f4/oauth2/v2.0/logout',
    ssoApiBaseUrl: 'https://api.stage.studiopulse.nbcuni.com'
  },
  backendApiUrl: 'https://api.stage.studiopulse.nbcuni.com'
};
